import SMSList from './SMSList'
export default SMSList;